<template>
  <ExpandTransition>
    <div
      v-if="internalShow"
      :class="classes"
      data-sb-regression="sb-banner"
    >
      <i
        v-if="showIcon"
        aria-hidden="true"
        :class="icon"
      />
      <div class="banner-content">
        <!--
        @slot text, components, or HtmlElements as children of the component
      -->
        <slot />
        <i
          v-if="dismissable"
          aria-hidden="true"
          class="sb-icon-x"
          @click="closeBanner"
        />
      </div>
    </div>
  </ExpandTransition>
</template>
<script>
import ExpandTransition from '@src/components/Transitions/Expand.vue';

/**
 * Displays a message inline in a formatted element that cannot be dismissed.
 */
export default {
  name: 'SbBanner',
  components: {
    ExpandTransition,
  },
  props: {
    /**
     * variation of the banner: default, info, success, warning, danger
     */
    variation: {
      type: String,
      default: 'default',
      validator: (value) => {
        return value.match(/(default|info|success|warning|danger)/);
      },
    },
    /**
     * If the banner can be closed.
     */
    dismissable: {
      type: Boolean,
      default: false,
    },
    /**
     * prop that allows you to sync the show / hide state of the banner
     */
    show: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    /**
    * Emitted when the close button on the banner is clicked.
    * @param {bool} value
    */
    'update:show',
  ],
  data: () => ({
    internalShow: true,
  }),
  computed: {
    classes() {
      let classes = [];
      classes = classes.concat(['sb-banner', this.variation]);
      return classes;
    },
    icon() {
      const iconMap = {
        info: 'sb-icon-info',
        success: 'sb-icon-checkmark-outline',
        warning: 'sb-icon-alert-circle',
        danger: 'sb-icon-alert-triangle',
      };
      return `sb-banner-icon ${iconMap[this.variation]}`;
    },
    showIcon() {
      return this.variation.match(/(info|success|warning|danger)/);
    },
  },
  watch: {
    show: {
      handler(newVal) {
        this.internalShow = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    closeBanner() {
      this.internalShow = false;
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="scss">
@import '@src/components/Banner/style/sb-banner.scss';
</style>
